
import * as React from 'react'
import type { SVGProps } from 'react'
const Checkmark = (props: SVGProps<SVGSVGElement>) => (
<svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.8125 14.8439C7.59917 14.8439 7.38584 14.7622 7.22334 14.5997L3.5775 10.954C3.25167 10.6282 3.25167 10.1014 3.5775 9.77567C3.90334 9.44983 4.43 9.44983 4.75584 9.77567L7.8125 12.8323L15.2442 5.40062C15.57 5.07479 16.0967 5.07479 16.4225 5.40062C16.7483 5.72646 16.7483 6.25312 16.4225 6.57896L8.40166 14.5997C8.23917 14.7622 8.02584 14.8439 7.8125 14.8439Z" fill="white"/>
</svg>

)
export default Checkmark